import clsx from "clsx";
import React from "react";

interface AuthFormContainerProps {
    title: string;
    children: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md';
    className?: string;
}

export const AuthFormContainer: React.FC<AuthFormContainerProps> = ({ title, children, maxWidth = 'xs', className }) => {

    const maxWidthClasses = {
        xs: 'max-w-sm',
        sm: 'max-w-md',
        md: 'max-w-lg'
    };

    return (
        <div className={clsx('mx-auto px-4 w-full', maxWidthClasses[maxWidth], className)}>
            <div className="mt-8 flex flex-col items-center">
                <h1 className="text-2xl font-medium mb-4"
                    style={{ color: 'var(--color-primary-950)' }}>
                    {title}
                </h1>

                {children}
            </div>
        </div>
    );
};